import React from 'react';

import { RadioBox } from 'components/shared/RadioBox';

const RadioBoxGroupField = ({
  helpers,
  haveError,
  field,
  form,
  onChanged,
  ...restProps
}: {
  helpers: any;
  haveError: any;
  field: any;
  form: any;
  onChanged: any;
} & Record<string, any>) => {
  const handleChange = (event: any) => {
    field.onChange(event);

    if (onChanged) {
      onChanged(event.target.value);
    }
  };

  return (
    <RadioBox {...restProps} checked={field.checked} onChange={handleChange} />
  );
};

export default React.memo(RadioBoxGroupField) as any;
